import { CaseStudyTestimonialInline } from './CaseStudyTestimonialInline';
export default CaseStudyTestimonialInline;
